module.exports = "pegasus/assets/social-1-basic-old.png";